import { useCallbackRef } from '@mantine/hooks'
import { ReactEditor, useSlateStatic } from 'slate-react'

export function useFocus() {
  const editor = useSlateStatic()
  return useCallbackRef(() => setTimeout(() => ReactEditor.focus(editor), 0))
}
